import { Component } from '@angular/core';

import { TakeUntilDestroy } from '../../../../common/take-until-destroy.decorator';
import { currentBuilderState } from '../../builder.state';
import { BuilderState } from '../../model/builder-state.model';
import { SelectionService } from '../../service/selection.service';

@Component({
    selector: 'cmps-report-builder-cache-date',
    templateUrl: './cache-date.component.html',
})
@TakeUntilDestroy()
export class CacheDateComponent {
    /** @private */
    _state: BuilderState;

    constructor(private readonly _selectionService: SelectionService) {
        this._state = currentBuilderState();
    }

    /** @private */
    _onClick(): void {
        this._selectionService.onCacheDateChange();
    }
}
